import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { SectionLabel, SectionHeading } from './ui/UI';
const features = ['Self-serve onboarding', 'Fast first report', 'Transparent SaaS pricing', 'Plain-English remediation', 'Fix verification', 'Shareable evidence', 'AI-security validation', 'MSSP-ready delivery', 'Upmarket controls when needed'];
export function MarketGap() {
  return <section className="relative w-full py-32 border-t border-white/5" data-id="element-618">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-619">
        <SectionLabel number="03" label="Market Gap" className="mb-8" data-id="element-620" />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-12" data-id="element-621">
          <div className="lg:col-span-7" data-id="element-622">
            <SectionHeading size="lg" data-id="element-623">
              Continuous validation exists —{' '}
              <span className="text-white/40" data-id="element-624">
                but it is still enterprise-shaped.
              </span>
            </SectionHeading>
          </div>
          <div className="lg:col-span-5 lg:pt-4" data-id="element-625">
            <p className="text-lg text-white/60 leading-relaxed" data-id="element-626">
              Autonomous pentesting, breach and attack simulation, and exposure
              management platforms have proven companies want evidence of real
              risk — but the first wave was built for mature security teams with
              enterprise budgets and dedicated operators.
            </p>
          </div>
        </div>

        {/* Feature grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-px bg-white/5 rounded-2xl overflow-hidden border border-white/5" data-id="element-627">
          {features.map((feature, i) => <motion.div key={i} initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: i * 0.05
        }} className="bg-[#070a0e] px-6 py-8 flex items-center gap-3 hover:bg-[#0a0f14] transition-colors" data-id="element-628">
              <div className="flex-shrink-0 w-5 h-5 rounded-full bg-[#1a8fd4]/20 border border-[#1a8fd4]/40 flex items-center justify-center" data-id="element-629">
                <Check className="w-3 h-3 text-[#1a8fd4]" strokeWidth={3} data-id="element-630" />
              </div>
              <span className="text-base text-white font-medium" data-id="element-631">
                {feature}
              </span>
            </motion.div>)}
        </div>

        <div className="mt-12 max-w-3xl" data-id="element-632">
          <p className="text-xl text-white/70 leading-relaxed" data-id="element-633">
            Periscan is{' '}
            <span className="text-white font-medium" data-id="element-634">
              not a lower-end security tool
            </span>
            . It is a modern SaaS version of a category that has been trapped in
            enterprise packaging.
          </p>
        </div>
      </div>
    </section>;
}